export default (value) => {
  return value.toUpperCase()
}
